<!--<div class="section intro">-->
<!--    <button mat-raised-button color="default" [routerLink]="'/' + organization?.code + '/athletes/' + athlete?.id + '/tests'">{{ 'TestsAll' | translate }}</button>-->
<!--</div>-->
<ng-container>
  <div class="section full-width">
    <div class="content">
      <div class="add-test mt-10 mb-20">
        <button
          mat-raised-button color="accent"
          (click)="addTestClicked()">
          {{ 'Add_test' | translate }}
        </button>
      </div>
      <div class="evaluation-athlete-list-wrapper">
        <mat-list class="list">

          <a [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/tests'"
             class="side-list-item rootitem"
             mat-list-item>
            <div class="active" *ngIf="activeTestId"></div>
            <h3 mat-line style="font-size: 13px;">{{ 'TestsAll' | translate }}</h3>
            <p matLine style="font-size: 13px;" class="side-list-itme-sub-title">{{ 'All_tests_displayed' | translate }}</p>
            <mat-divider class="divider" [inset]="true"></mat-divider>
          </a>

          <a [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/tests/' + test.id"
             mat-list-item
             *ngFor="let test of tests"
             class="side-list-item"
          >
            <div class="item-block">
              <div class="item-block-left-part">
                <div class="active" *ngIf="test.id === activeTestId"></div>
                <div class="text-div">
                  <h3 mat-line>{{ test.name }}</h3>
                  <p matLine class="side-list-itme-sub-title">{{ test.date|appDate:'mediumDate' | default:'-' }}</p>
                </div>
              </div>
              <ng-container *ngIf="hasOtherThanReadRights(test)">
                <button
                  mat-icon-button
                  (click)="onVerticalMenuClick($event)"
                  [matMenuTriggerFor]="rowMoreMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                  <button
                    *ngIf="!test.read_only && test.rights.duplicate"
                    mat-menu-item
                    (click)="onDuplicateClicked(test)">
                    <mat-icon>file_copy</mat-icon>
                    <span>{{ 'Duplicate' | translate }}</span>
                  </button>
                  <button
                    *ngIf="!test.read_only && test.rights.edit"
                    mat-menu-item
                    (click)="onEditClicked(test)">
                    <mat-icon>edit</mat-icon>
                    <span>{{ 'Edit' | translate }}</span>
                  </button>
                  <button
                    *ngIf="!test.read_only && test.rights.delete"
                    mat-menu-item
                    (click)="onDeleteClicked(test)">
                    <mat-icon>delete</mat-icon>
                    <span>{{ 'Delete' | translate }}</span>
                  </button>
                </mat-menu>
              </ng-container>
            </div>

            <mat-divider class="divider" [inset]="true"></mat-divider>
          </a>
        </mat-list>
      </div>
    </div>
  </div>
</ng-container>

